import React, { Component, useReducer } from 'react';
import {Collapse, SignupToggler,SignupBrand,Nav,Navday,NavLink,UncontrolledDropdown,
 Button, Input, Row, Col, Dropdown, DropdownToggle, DropdownMenu, Dropdownday, Form, Container, Label, InputGroup} from "reactstrap";
import axios from 'axios';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import {Helmet} from 'react-helmet'
import {Backend_Url} from './backend_url'
import Background_Image from '../images/image_3.jpg'
import Pricing from './pricing'
import Trainers from './trainers'
import Goals from './coach'
import TrainingMethod from './method'
import { FaDivide, FaFirstdraft } from 'react-icons/fa';
import StripeCheckout from './stripe_checkout'
//import "react-loader-spinner/dist/loader/css/react-spinner-loader.css"
import { Triangle } from 'react-loader-spinner'

  class Signup extends Component{
    static propTypes = {
      cookies: instanceOf(Cookies).isRequired
    };
    constructor(props) { 
      super(props);
      this.state = {
          firstname: '', 
          lastname: '', 
          email: '', 
          phonenumber: Number, 
          address: '', 
          password: '',
          password_confirmation: '',
          loading: false,
          current_render: 'pricing',
          selected_trainer: '',
          goals: '',
          training_method: '',
          weekly_schedule: '',
          selected_day: 'Monday',
          Monday: false,
          Tuesday: false,
          Wednesday: false,
          Thursday: false,
          Friday: false,
          Saturday: false,
          Sunday: false,
          start_time: '',
          end_time: '',
          time_button_disabled: false,
          weight: null,
          height: null,
          left_bicep: Number,
          right_bicep: Number,
          chest: Number,
          waist: Number,
          hips: Number,
          calf: Number,
          left_leg: Number,
          right_leg: Number,
          payment_success: false,
          plan: '',
          trials: 0
      };

      this.ChangeCurrentRender = (new_render) => {
        var current_render = this.state.current_render
        var change = false
        if (current_render == 'weekly_schedule'){
          if (this.state.weekly_schedule == ''){
            alert('You need to set a weekly schedule.')
          }else{
            change = true
          }
        }else if (current_render == 'goals_page'){
          if(this.state.goals == ''){
            alert('You need to set your fitness goals.')
          }else{
            change = true
          }
        }else if (current_render == 'training_method'){
          if(this.state.training_method == ''){
            alert('You need to set your training methods.')
          }else{
            change = true
          }
        }else if (current_render == 'body_metrics'){
          if (
            this.state.weight == Number ||
            this.state.height == Number ||
            this.state.left_bicep == Number ||
            this.state.right_bicep == Number || 
            this.state.chest == Number ||
            this.state.waist == Number ||
            this.state.hips == Number ||
            this.state.calf == Number ||
            this.state.left_leg == Number ||
            this.state.right_leg == Number 
          ){
            alert('Enter the required body metrics')
          }else{
            change = true
          }
        }else{
          change = true
        }

        if(change == true){
          this.setState({current_render: new_render})
          window.scrollTo(0, 0)
        }
      }

      this.UpdateGoals = (goal) => {
        this.setState({goals: this.state.goals + goal + ', '})
      }


      this.UpdateTrainingMethod = (method) => {
        this.setState({training_method: this.state.training_method + method + ', '})
      }

      this.PaymentSuccessful = () => {
        this.setState({payment_success: true})
        this.Signup()
      }

      this.SaveDaySchedule = () => {
        this.setState({time_button_disabled: true})
        if(this.state.weekly_schedule == ''){
          this.setState({weekly_schedule: this.state.weekly_schedule + this.state.selected_day + ' ' + this.state.start_time + ' - ' + this.state.end_time + ', '})
          alert(this.state.selected_day + ' ' + this.state.start_time + ' - ' + this.state.end_time + ' added to weekly schedule.')
          this.setState({time_button_disabled: false})
        }else if(this.state.weekly_schedule.includes(this.state.selected_day)){
          if (window.confirm(this.state.selected_day + ' schedule already exists. Do you wish to overide it?')) {
            var schedule_array = this.state.weekly_schedule.split(',')
            var index = schedule_array.indexOf(this.state.selected_day)
            schedule_array[index] = this.state.selected_day + ' ' + this.state.start_time + ' - ' + this.state.end_time

            this.setState({weekly_schedule: schedule_array.toString()})
            alert(this.state.selected_day + ' ' + this.state.start_time + ' - ' + this.state.end_time + ' added to weekly schedule.')
            this.setState({time_button_disabled: false})
          } else {
            console.log(this.state.selected_day + 'schedule not altered.')
            this.setState({time_button_disabled: false})
          }
        }else{
          this.setState({weekly_schedule: this.state.weekly_schedule + this.state.selected_day + ' ' + this.state.start_time + ' - ' + this.state.end_time + ', '})
          alert(this.state.selected_day + ' ' + this.state.start_time + ' - ' + this.state.end_time + ' added to weekly schedule.')
          this.setState({time_button_disabled: false})
        }
      }
      
      this.CheckboxChange = (e) => {
        var day = e.target.name;

        this.state[day] = !this.state[day]
        this.setState({selected_day: day})
      };

      this.HandleChange = (e) =>{
        this.setState({[e.target.name]: e.target.value});
      };
      this.Signup = (e) => {
        var plan = this.state.plan
        var account_type = this.props.match.params.account_type
        var payment_success = this.state.payment_success

        // if ((plan == 'Basic') && (payment_success == false)){
        //   this.setState({current_render: 'payment'})
        // }else{
          // e.preventDefault()
          this.setState({loading: true})
          const { cookies } = this.props
          var firstname = this.state.firstname
          var lastname = this.state.lastname
          var email = this.state.email
          var phonenumber = this.state.phonenumber
          var address = this.state.address
          var password = this.state.password
          var password_confirmation = this.state.password_confirmation
          
          if (
            firstname == '' ||
            lastname == '' ||
            email == '' ||
            phonenumber == Number ||
            password == '' ||
            password_confirmation == ''
          ){
            alert('Fill in all fields')
            this.setState({loading: false})
          }else if(password != password_confirmation) {
            alert('Your password and its confirmation do not match')
            this.setState({loading: false})
          }else{
            var data = new FormData()
            data.append('firstname', firstname)
            data.append('lastname', lastname)
            data.append('email', email)
            data.append('phonenumber', phonenumber)
            data.append('password', password)
            data.append('account_type', this.props.match.params.account_type)
    
            data.append('schedule', this.state.weekly_schedule)
            data.append('goals', this.state.goals)
            data.append('methods', this.state.training_method)
  
            data.append('plan', this.state.plan)
    
            data.append('weight', this.state.weight)
            data.append('height', this.state.height)
            data.append('left_bicep', this.state.left_bicep)
            data.append('right_bicep', this.state.right_bicep)
            data.append('chest', this.state.chest)
            data.append('waist', this.state.waist)
            data.append('hips', this.state.hips)
            data.append('calf', this.state.calf)
            data.append('left_leg', this.state.left_leg)
            data.append('right_leg', this.state.right_leg)
    
            axios.post(Backend_Url + 'signup', data)
            .then((res) => {
                let result = res.data
                if(result == 'Email already registered'){
                    alert('This email address has already been registered on this platform. Proceed to signin.')
                    this.setState({loading: false})
                }else if(result == 'Phone number already registered'){
                    alert('This phonenumber has already been registered on this platform.')
                    this.setState({loading: false})
                }else if(result == 'Signup successful'){
                    this.setState({loading: false})
                    let port = (window.location.port ? ':' + window.location.port : '')
                    window.location.href = '//' + window.location.hostname + port + '/email-verification/'  + email
                    // window.location.href = '//' + window.location.hostname + port + '/signin'
                    // this.setState({current_render: 'congratulations_page'})
                }else{
                  this.setState({loading: false})
                    alert('An network error has occured, please try again.')
                }
            }).catch((error) => {
              // this.Signup()
              alert('An network error has occured, please try again.')
              this.setState({loading: false})
            })
          }
        // }
      }

      this.SetPlan = (plan) => {
        this.setState({plan: plan})
      }

      this.CurrentRender = () => {
        var current_render = this.state.current_render

        if (current_render == 'pricing'){
          return <Pricing ChangeCurrentRender = {this.ChangeCurrentRender} SetPlan = {this.SetPlan}/>
        }else if (current_render == 'trainers_page'){
          return <>
            <Container>
              <br/><br/>
              <Row style={{marginRight: '0px'}}>
                <Col sm='3'>
                  <Button onClick={() => this.ChangeCurrentRender('signup_form')} style={{backgroundColor: 'inherit', color: 'inherit', border: '1px solid #1faced'}}>
                    Continue {'>>>'}
                  </Button>
                </Col>
              </Row>
            </Container>
            <Trainers source_page = 'signup' HandleChange={this.HandleChange}/>
          </>
        }else if (current_render == 'congratulations_page'){
          return <div>
            <Helmet>
              <title>Congratulations</title>
              {/* <meta name="description" content="" /> */}
            </Helmet>
            <div style={{backgroundImage: "url(" + Background_Image + ")", margin: '0px', minHeight: '550px'}}>
              <div style={{backgroundColor: '#ffffff', minHeight: '550px', opacity: 0.9}}>
                <br/>
                <p style={{marginTop: '150px'}}>
                  Congratulations for signing up to the platform. When space is avalable on the Beta program you will 
                  be contacted. Thank you.
                </p>
              </div>
            </div>
          </div>
        }else if (current_render == 'payment') {
          return  <div>
            <Helmet>
              <title>Payment</title>
              {/* <meta name="description" content="" /> */}
            </Helmet>
            <div style={{backgroundImage: "url(" + Background_Image + ")", margin: '0px', minHeight: '550px'}}>
              <div style={{backgroundColor: '#ffffff', minHeight: '550px', opacity: 0.9}}>
                <br/>
                <p style={{marginTop: '150px'}}>
                  Make a payment to complete registration under the basic plan.
                </p>
                <StripeCheckout price={9.99} origin='basic_plan' PaymentSuccessful={this.PaymentSuccessful}/>
              </div>
            </div>
          </div>
        }else if (current_render == 'signup_form'){
          return <div>
            <Helmet>
              <title>Sign Up</title>
              {/* <meta name="description" content="" /> */}
            </Helmet>
            <Row style={{backgroundImage: "url(" + Background_Image + ")", margin: '0px', minHeight: '550px'}}>
              <Col style={{backgroundColor: '#1faced', minHeight: '600px', color: '#FFFFFF', opacity: 0.9}}>
                <h3 style={{marginTop: '170px'}}>
                  Convenience at heart.
                </h3>
                <h5 style={{marginTop: '100px'}}>
                  Already registered? <a href='/signin' style={{color: '#FFFFFF'}}>Click here to signin.</a>
                </h5>
              </Col>
              <Col sm='6' style={{opacity: 0.9, backgroundColor: '#F8F9FA'}}>
                <br/><br/>
                <h4 style={{color: '#1faced'}}>
                  SignUp
                </h4>
                <br/><br/><br/>
                <Form onSubmit={this.Signup}>
                  <Row>
                    <Col style={{paddingLeft: '100px', paddingRight: '100px'}}>
                      <Input style={{border: 'none', borderBottom: '1px solid #1faced', color: '#3360A2', backgroundColor: 'inherit'}} placeholder="Firstname" type="text" name="firstname" id="firstname"
                        value={this.state.firstname} onChange={this.HandleChange} />
                    </Col>
                  </Row>
                  <br/><br/>
                  <Row>
                    <Col style={{paddingLeft: '100px', paddingRight: '100px'}}>
                      <Input style={{border: 'none', borderBottom: '1px solid #1faced', color: '#3360A2', backgroundColor: 'inherit'}} placeholder="Lastname" type="text" name="lastname" id="lastname"
                        value={this.state.lastname} onChange={this.HandleChange} />
                    </Col>
                  </Row>
                  <br/><br/>
                  <Row>
                    <Col style={{paddingLeft: '100px', paddingRight: '100px'}}>
                      <Input style={{border: 'none', borderBottom: '1px solid #1faced', color: '#3360A2', backgroundColor: 'inherit'}} placeholder="Email" type="text" name="email" id="email"
                        value={this.state.email} onChange={this.HandleChange} />
                    </Col>
                  </Row>
                  <br/><br/>
                  <Row>
                    <Col style={{paddingLeft: '100px', paddingRight: '90px'}}>
                      <Input style={{border: 'none', borderBottom: '1px solid #1faced', color: '#3360A2', backgroundColor: 'inherit'}} placeholder="Phonenumber" type="number" name="phonenumber" id="phonenumber"
                        value={this.state.phonenumber} onChange={this.HandleChange} />
                    </Col>
                  </Row>
                  <br/><br/>
                  <Row>
                    <Col style={{paddingLeft: '100px', paddingRight: '100px'}}>
                      <Input style={{border: 'none', borderBottom: '1px solid #1faced', color: '#3360A2', backgroundColor: 'inherit'}} placeholder="Password" type="password" name="password" id="password"
                        value={this.state.password} onChange={this.HandleChange} />
                    </Col>
                  </Row>
                  <br/><br/>
                  <Row>
                    <Col style={{paddingLeft: '100px', paddingRight: '100px'}}>
                      <Input style={{border: 'none', borderBottom: '1px solid #1faced', color: '#3360A2', backgroundColor: 'inherit'}} placeholder="Password Confirmation" type="password" name="password_confirmation" id="password_confirmation"
                        value={this.state.password_confirmation} onChange={this.HandleChange} />
                    </Col>
                  </Row>
                  <br/>
                  By signing up you are agreeing to our <a href='/terms-and-conditions'>Terms and Conditions</a> as well as our <a href='/privacy-policy'>Privacy Policy</a>. Click on the highlighted text to read them.
                  <br/><br/>
                  <Button type='submit' style={{backgroundColor: '#1faced', color: '#FFFFFF', border: 'none', borderRadius: '20px', fontWeight: 'bold', width: '120px'}}>
                    Signup
                  </Button>
                </Form>
                <br/><br/><br/>
              </Col>
            </Row>
          </div>
        }else if (current_render == 'weekly_schedule'){
          return <div>
            <Helmet>
              <title>Weekly Schedule</title>
              {/* <meta name="description" content="" /> */}
            </Helmet>
            <div style={{backgroundImage: "url(" + Background_Image + ")", margin: '0px', minHeight: '550px'}}>
              <div style={{backgroundColor: '#ffffff', minHeight: '550px', opacity: 0.9}}>
                <br/><br/>
                <h4>
                  Weekly Schedule Setup
                </h4>
                <br/>
                <Container style={{textAlign: 'left'}}>
                  <Row style={{marginRight: '0px'}}>
                    <Col xs='6'>
                      <h5>
                        Select days of the week you want to train
                      </h5>
                      <br/>
                      <Input type="checkbox" checked={this.state.Monday} 
                        name="Monday" onChange={this.CheckboxChange}/>{' '}<h6>Monday</h6>
                      <br/>
                      <Input type="checkbox" checked={this.state.Tuesday} 
                        name="Tuesday" onChange={this.CheckboxChange}/>{' '}<h6>Tuesday</h6>
                      <br/>
                      <Input type="checkbox" checked={this.state.Wednesday} 
                        name="Wednesday" onChange={this.CheckboxChange}/>{' '}<h6>Wednesday</h6>
                      <br/>
                      <Input type="checkbox" checked={this.state.Thursday} 
                        name="Thursday" onChange={this.CheckboxChange}/>{' '}<h6>Thursday</h6>
                      <br/>
                      <Input type="checkbox" checked={this.state.Friday} 
                        name="Friday" onChange={this.CheckboxChange}/>{' '}<h6>Friday</h6>
                      <br/>
                      <Input type="checkbox" checked={this.state.Saturday} 
                        name="Saturday" onChange={this.CheckboxChange}/>{' '}<h6>Saturday</h6>
                      <br/>
                      <Input type="checkbox" checked={this.state.Sunday} 
                        name="Sunday" onChange={this.CheckboxChange}/>{' '}<h6>Sunday</h6>
                      <br/>
                    </Col>
                    <Col>
                      <h5>
                        Time Schedule For {this.state.selected_day}:
                      </h5>
                      <br/>
                      <Row style={{marginRight: '0px'}}>
                        <Col sm='6'>
                          Start Time:
                          <Input type='time' name='start_time' value={this.state.start_time} onChange={this.HandleChange}
                            style={{}}/>
                        </Col>
                        <Col>
                          End Time:
                          <Input type='time' name='end_time' value={this.state.end_time} onChange={this.HandleChange}
                            style={{}}/>
                        </Col>
                      </Row>
                      <br/>
                      <Button disabled={this.state.time_button_disabled} onClick={this.SaveDaySchedule} style={{backgroundColor: '#1faced', color: '#FFFFFF', border: 'none', borderRadius: '20px', fontWeight: 'bold', width: ''}}>
                        Save {this.state.selected_day} Schedule
                      </Button>
                      <br/><br/><br/><br/>
                      <h5>
                        Current Schedule:
                      </h5>
                      <br/>
                      { 
                        this.state.weekly_schedule === ''
                        ? <div>
                          No schedule setup yet.
                        </div>
                        : <div>{this.state.weekly_schedule}</div>
                      }
                      <br/><br/>
                      <div style={{textAlign: 'right'}}>
                        <Button disabled={this.state.time_button_disabled} onClick={() => this.ChangeCurrentRender('goals_page')} style={{backgroundColor: '#1faced', color: '#FFFFFF', border: 'none', borderRadius: '20px', fontWeight: 'bold', width: ''}}>
                          Save Weekly Schedule
                        </Button>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </div>
            </div>
          </div>
        }else if (current_render == 'goals_page'){
          return <Goals UpdateGoals = {this.UpdateGoals} ChangeCurrentRender = {this.ChangeCurrentRender}/>
        }else if (current_render == 'training_method'){
          return <TrainingMethod ChangeCurrentRender = {this.ChangeCurrentRender} UpdateTrainingMethod = {this.UpdateTrainingMethod}/>
        }else if (current_render == 'body_metrics'){
          return <div>
            <Helmet>
              <title>Body Metrics</title>
              {/* <meta name="description" content="" /> */}
            </Helmet>
            <div style={{backgroundImage: "url(" + Background_Image + ")", margin: '0px', minHeight: '550px'}}>
              <div style={{backgroundColor: '#ffffff', minHeight: '550px', opacity: 0.9}}>
                <Container>
                  <h5 style={{fontWeight: 'bold'}}>Your body metrics</h5>
                  <br/><br/>
                  <Row>
                    <Col sm='3'>
                      Weight (kgs):
                      <br/>
                      <Input name='weight' value={this.state.weight}  placeholder='Weight' onChange={this.HandleChange} type='number'
                        style={{border: 'none', borderBottom: '1px solid grey', width: '100%'}}/>
                    </Col>
                    <Col>
                      Height (cms):
                      <br/>
                      <Input name='height' value={this.state.height}  placeholder='Height' onChange={this.HandleChange} type='number'
                        style={{border: 'none', borderBottom: '1px solid grey', width: '100%'}}/>
                    </Col>
                    <Col>
                      Left bicep (cms):
                      <br/>
                      <Input name='left_bicep' value={this.state.left_bicep}  placeholder='Left bicep' onChange={this.HandleChange} type='number'
                        style={{border: 'none', borderBottom: '1px solid grey', width: '100%'}}/>
                    </Col>
                    <Col>
                      Right bicep (cms):
                      <br/>
                      <Input name='right_bicep' value={this.state.right_bicep}  placeholder='Right bicep' onChange={this.HandleChange} type='number'
                        style={{border: 'none', borderBottom: '1px solid grey', width: '100%'}}/>
                    </Col>
                  </Row>
                  <br/><br/>
                  <Row>
                    <Col sm='3'>
                      Chest (cms):
                      <br/>
                      <Input name='chest' value={this.state.chest}  placeholder='Chest' onChange={this.HandleChange} type='number'
                        style={{border: 'none', borderBottom: '1px solid grey', width: '100%'}}/>
                    </Col>
                    <Col>
                      Waist (cms):
                      <br/>
                      <Input name='waist' value={this.state.waist}  placeholder='Waist' onChange={this.HandleChange} type='number'
                        style={{border: 'none', borderBottom: '1px solid grey', width: '100%'}}/>
                    </Col>
                    <Col>
                      Hips (cms):
                      <br/>
                      <Input name='hips' value={this.state.hips}  placeholder='Hips' onChange={this.HandleChange} type='number'
                        style={{border: 'none', borderBottom: '1px solid grey', width: '100%'}}/>
                    </Col>
                    <Col>
                      Calf (cms):
                      <br/>
                      <Input name='calf' value={this.state.calf}  placeholder='Calf' onChange={this.HandleChange} type='number'
                        style={{border: 'none', borderBottom: '1px solid grey', width: '100%'}}/>
                    </Col>
                  </Row>
                  <br/><br/>
                  <Row>
                    <Col sm='3'>
                      Left leg (cms):
                      <br/>
                      <Input name='left_leg' value={this.state.left_leg}  placeholder='Left leg' onChange={this.HandleChange} type='number'
                        style={{border: 'none', borderBottom: '1px solid grey', width: '100%'}}/>
                    </Col>
                    <Col>
                      Right leg (cms):
                      <br/>
                      <Input name='right_leg' value={this.state.right_leg}  placeholder='Right leg' onChange={this.HandleChange} type='number'
                        style={{border: 'none', borderBottom: '1px solid grey', width: '100%'}}/>
                    </Col>
                    <Col>

                    </Col>
                    <Col>

                    </Col>
                  </Row>
                  <br/><br/>
                  <Button onClick={() => this.ChangeCurrentRender('signup_form')} style={{color: '#1faced', fontWeight: 'bold', border: '3px solid #1FACED', borderRadius: '20px', backgroundColor: 'inherit', width: '300px'}}>
                    Next {'>>>'}
                  </Button>
                </Container>
              </div>
            </div>
          </div>
        }
      }
    }

    componentDidMount() {
      const { cookies } = this.props;
      if(cookies.get('token')!=null){
        let port = (window.location.port ? ':' + window.location.port : '');
        window.location.href = '//' + window.location.hostname + port + '/user-home';
      }else{
        if (this.props.match.params.account_type == 'trainer'){
          this.setState({current_render: 'signup_form'})
        }
        if (this.props.match.params.signup_type == 'direct'){
          this.setState({current_render: 'signup_form'})
        }
        if (this.props.match.params.signup_type == 'Basic'){
          this.setState({current_render: 'weekly_schedule', plan: 'Basic'})
        }
        if (this.props.match.params.signup_type == 'Premium'){
          this.setState({current_render: 'trainers_page', plan: 'Premium'})
        }
      }
    }




    render() {
      if (this.state.loading == true){
        return (
          <div style={{backgroundImage: "url(" + Background_Image + ")"}}>
            <div style={{opacity: '0.9', backgroundColor: '#E0DBDF', minHeight: '600px'}}>
              <Helmet>
                <title>SIGN UP - ONFIT</title>
                {/* <meta name="description" content="" /> */}
              </Helmet>

              <br/>
              <h1 style={{color: '#47525E', fontFamily: 'Knewave', marginTop: '50px', fontWeight: 'bold'}}>
                ONFIT
              </h1>
              <br/><br/>
              <Triangle
                  color="#1FACED"
                  height={130}
                  width={130}
              />
              <h3 style={{marginTop: '50px'}}>
                Loading...
              </h3>
              <h6 style={{marginTop: '50px'}}>
                Taking too long to load? Check your internet connection and reload the page.
              </h6>
              <br/><br/>
            </div>
          </div>
        )
      }

      return (
        <>
          <this.CurrentRender/>
        </>
      );
    }

  };
  
  export default withCookies(Signup);